import routes from './routes';

/**
 * Resolves the first screen after login from the auth API user object.
 * Precedence matches the former Login flow: equipment trial overrides is_global when both apply.
 */
export function getPostLoginPath(user) {
  if (!user) {
    return routes.private.main;
  }
  if (user.agency?.trial_status === 'equipment') {
    return user.agency?.is_settings_complete
      ? `${routes.private.equipment}?active=0`
      : routes.private.fboSettings;
  }
  if (user.is_global) {
    return `${routes.private.inspections}?tab=daily`;
  }
  if (user.is_corporate && !user.is_regional_corporate) {
    return routes.private.corporateDashboard;
  }
  if (user.is_inspector) {
    return routes.private.dashboard;
  }
  return routes.private.main;
}
